import { toast } from 'react-toastify';
import { getTranslatedKey } from './TranslateUtils';
import { getInfoPuntUrls } from './infoPuntUtils';

//funcion para normalizar un texto (lo pone a mayusculas y le quita tildes)
export function normalizeText(text) {
  return text
    ?.toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

//funcion para saber si un string es un enlace
export function checkUrl(stringUrl) {
  var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  var regex = new RegExp(urlRegex);
  if (stringUrl !== undefined && stringUrl !== null && stringUrl.match !== undefined && stringUrl.match !== null && stringUrl.match(regex))
    return true;
  return false;
}

//funcion para saber si un string es una fecha
export function checkDate(string) {
  if (string) {
    const length = string.length;
    if (length && string[length - 1] === 'Z') {
      const date = new Date(string);
      if (date && !isNaN(date.getTime())) {
        return true;
      } else {
        return false;
      }
    }
  }
  return false;
}

export function ConvertDDToDMS(dd) {
  let deg = dd | 0; // truncate dd to get degrees
  let frac = Math.abs(dd - deg); // get fractional part
  let min = (frac * 60) | 0; // multiply fraction by 60 and truncate
  let sec = frac * 3600 - min * 60;
  return deg + 'º ' + min + "' " + sec.toFixed(2) + '"';
}

export function xmlToJson(xml) {
  // Create the return object
  let obj = {};

  if (xml?.nodeType === 1) {
    // element
    // do attributes
    if (xml?.attributes.length > 0) {
      obj['@attributes'] = {};
      for (let j = 0; j < xml?.attributes.length; j++) {
        let attribute = xml?.attributes.item(j);
        obj['@attributes'][attribute.nodeName] = attribute.nodeValue;
      }
    }
  } else if (xml?.nodeType === 3) {
    // text
    obj = xml.nodeValue;
  }

  // do children
  if (xml?.hasChildNodes()) {
    for (let i = 0; i < xml?.childNodes.length; i++) {
      let item = xml?.childNodes.item(i);
      let nodeName = item.nodeName;
      if (typeof obj[nodeName] == 'undefined') {
        obj[nodeName] = xmlToJson(item);
      } else {
        if (typeof obj[nodeName].push == 'undefined') {
          let old = obj[nodeName];
          obj[nodeName] = [];
          obj[nodeName].push(old);
        }
        obj[nodeName].push(xmlToJson(item));
      }
    }
  }
  return obj;
}

export function IsNumeric(num) {
  return num >= 0 || num < 0;
}

export function xmlStringToJSON(xmlString) {
  const jsonData = {};
  for (const result of xmlString.matchAll(/(?:<(\w*)(?:\s[^>]*)*>)((?:(?!<\1).)*)(?:<\/\1>)|<(\w*)(?:\s*)*\/>/gm)) {
    const key = result[1] || result[3];
    const value = result[2] && xmlStringToJSON(result[2]); //recusrion
    jsonData[key] = (value && Object.keys(value).length ? value : result[2]) || null;
  }
  return jsonData;
}

//comprobar que el campo no está vacío
function checkEmpty(inputText, inputField) {
  if (inputText === '') {
    toast.warn(getTranslatedKey('warnField') + inputField + getTranslatedKey('isMandatory'), { autoClose: 2500, pauseOnHover: true });
    return false;
  }
  return true;
}

//comprobar que el campo es un número
function checkNumber(inputField, inputText) {
  if (isNaN(parseFloat(inputText))) {
    toast.warn(getTranslatedKey('warnField') + inputField + getTranslatedKey('shouldNumber'), { autoClose: 2500, pauseOnHover: true });
    return false;
  }
  return true;
}

//comprobar que les coordenades compleixen el format necessari
export function checkCoords(isLonLat, x, y) {
  let parsedX = parseFloat(x.replace(/\s/g, ''));
  let parsedY = parseFloat(y.replace(/\s/g, ''));
  if (isLonLat) {
    if (parsedX <= 180 && parsedX >= -180 && parsedY <= 90 && parsedY >= -90) return true;
    else {
      toast.warn(getTranslatedKey('coordinateFormat'));
      return false;
    }
  } else {
    if (parsedX <= 536000 && parsedX >= 258000 && parsedY <= 4752000 && parsedY >= 4485000) return true;
    else {
      toast.warn(getTranslatedKey('coordinateFormat'));
      return false;
    }
  }
}

//comprobar que los text input de cerca avançada cumplen los requisitos (no vacio si es obligatorio y numero si es numerico)
export function checkFormat(element) {
  if (element.required) {
    if (!checkEmpty(element.value, element.key)) return false;
    if (element.isNumber) {
      if (!checkNumber(element.key, element.value)) return false;
    }
  }
  if (!element.required && element.isNumber) {
    if (element.value !== '' && !checkNumber(element.key, element.value)) return false;
  }
  return true;
}

//comprobar que las coordenadas de la cerca son correctas
export function getCoordinates(searchTerm) {
  var arCoord = searchTerm.split(' ');
  if (arCoord.length === 2 && isValidNumber(arCoord[0]) && isValidNumber(arCoord[1])) {
    return arCoord;
  }

  arCoord = searchTerm.split(',');
  if (arCoord.length === 2 && isValidNumber(arCoord[0]) && isValidNumber(arCoord[1])) {
    return arCoord;
  }

  arCoord = searchTerm.split(';');
  if (arCoord.length === 2 && isValidNumber(arCoord[0]) && isValidNumber(arCoord[1])) {
    return arCoord;
  }

  return null;
}

//comprobar que las coordenadas de la cerca son correctas
export function isValidNumber(value) {
  return /^(^\d+\.\d+$)|(^\d+$)/.test(value.replace(/\s/g, ''));
}

export const isDeepEqual = (object1, object2) => {
  const objKeys1 = Object.keys(object1).filter((key) => !isIgnoredKey(key));
  const objKeys2 = Object.keys(object2).filter((key) => !isIgnoredKey(key));

  if (objKeys1.length !== objKeys2.length) {
    return false;
  }

  for (var key of objKeys1) {
    const value1 = object1[key];
    const value2 = object2[key];
    const isObjects = isObject(value1) && isObject(value2);

    if ((isObjects && !isDeepEqual(value1, value2)) || (!isObjects && value1 !== value2)) {
      return false;
    }
  }

  return true;
};

const isIgnoredKey = (key) => {
  const ignoredKeys = ['0', 'change', 'listeners_', 'geometry'];
  return ignoredKeys.includes(key);
};

const isObject = (object) => {
  return object != null && typeof object === 'object';
};

export const docList = ['doc', 'docx', 'pdf', 'txt', 'csv', 'xls', 'xlsx', 'ppt', 'pptx', 'odt', 'ods', 'odp', 'rtf', 'xml'];
export const imageList = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'webp', 'svg', 'ico', 'jfif', 'pjpeg', 'pjp', 'heif', 'bat', 'raw'];

export const replaceHTTPWithHTTPS = (url) => {
  if (url.startsWith('http:')) {
    return url.replace('http:', 'https:');
  }
  return url;
};

export const urlNameSelector = (url) => {
  let ext = url.split('.').pop().toLowerCase();
  if (docList.findIndex((format) => format === ext) !== -1) {
    return getTranslatedKey('urlDoc');
  } else if (imageList.findIndex((format) => format === ext) !== -1) {
    return getTranslatedKey('urlImg');
  } else {
    return getTranslatedKey('urlWeb');
  }
};

export const solrTextFormat = (text) => {
  const specialCharacters = /[+\-&|(){}[\]^"~:\\]/g;
  const formattedString = text.replace(specialCharacters, (match) => `\\${match}`);
  return formattedString;
};

export const rasterInfoPunt = async (array, bbox, clickPixel, arrayLayers) => {
  const fetchUrls = getInfoPuntUrls(array, bbox, clickPixel, true);
  for (const urlObj of fetchUrls) {
    let url = urlObj.url + '?';
    const formattedBody = urlObj.body;
    delete formattedBody.CQL_FILTER;
    formattedBody.INFO_FORMAT = 'text/xml';
    Object.keys(formattedBody).forEach((key) => {
      url = url + '&' + key + '=' + urlObj.body[key];
    });

    const response = await fetch(url);
    const responseText = await response.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(responseText, 'text/xml');
    const featureMembers = xmlDoc.getElementsByTagName('gml:featureMember');
    const features = [];
    for (let i = 0; i < featureMembers.length; i++) {
      const featureMember = featureMembers[i].children[0];
      const featureProperties = {};

      for (let j = 0; j < featureMember.children.length; j++) {
        const property = featureMember.children[j];
        const propertyName = property.tagName.split(':')[1];
        const propertyValue = parseFloat(property.textContent) || property.textContent;
        featureProperties[propertyName] = propertyValue;
      }
      const layerName = featureMember.nodeName.split(':')[1];
      const title = arrayLayers.find((layer) => layer.getName() === layerName).getTitle();
      const feature = {
        type: 'Feature',
        layerName: title || layerName || '',
        raster: true,
        geometry: null,
        values_: featureProperties
      };

      features.push(feature);
    }
    return features;
  }
};
